import React from 'react'
import { nudgeTextGradient } from 'src/components/subscriptions/preview/SubscriptionPlanPreview'
import usePaymentPage from 'src/lib/contexts/PaymentPageContext'
import { useLocale } from 'src/lib/hooks/useLocal'
import { classNames } from 'src/lib/utils/helpers'

const PurchaseModeTabsPreview = () => {
  const { t } = useLocale()
  const {
    getters: { subscriptionConfig, purchaseMode },
    actions: { setSelection }
  } = usePaymentPage()

  const { subscriptionCard, tabNudge } = subscriptionConfig.layoutUi

  const isSubscribe = purchaseMode === 'SUBSCRIBE'
  const nudgeGradient = nudgeTextGradient(subscriptionCard.highlightBackgroundColor)

  const tabClassName = (isActive: boolean) =>
    classNames(
      'flex flex-1 flex-col items-center justify-center gap-0.5 py-1.5',
      isActive ? 'border-b-2 border-coal-dark bg-white' : ''
    )

  const labelClassName = (isActive: boolean) =>
    classNames('h-4', isActive ? 'text-text-xs-semibold text-coal-dark' : 'text-text-xs-medium text-coal-light')

  return (
    <div className='flex border-b-1 border-zinc-200' onClick={() => setSelection({ type: 'LAYOUT', id: null })}>
      <div className={tabClassName(!isSubscribe)}>
        <span className={labelClassName(!isSubscribe)}>{t('payments_tab.pay_once')}</span>
      </div>
      <div className={tabClassName(isSubscribe)}>
        <span className={labelClassName(isSubscribe)}>{t('payments_tab.subscribe')}</span>
        {Boolean(tabNudge) && (
          <span
            className='animate-gradient-sweep bg-clip-text text-text-xs-semibold text-transparent opacity-80'
            style={{ backgroundImage: nudgeGradient, backgroundSize: '200% 100%' }}
          >
            {tabNudge}
          </span>
        )}
      </div>
    </div>
  )
}

export default PurchaseModeTabsPreview
